import { useMediaQuery } from './useMediaQuery';

export const useIsMobile = () => {
  const { matches: isMobile } = useMediaQuery('(max-width: 600px)');

  return { isMobile };
};
